import axios from 'axios'
import router from '../../router'

const defaultState = () => {
  return {
    products: [],
    token: '',
    shipping: '',
    recipient: {
      name: '',
      tal: '',
      email: ''
    },
    shop: {
      id: '',
      name: '',
      address: ''
    },
    lastOrderPrice: 0
  }
}

const state = defaultState()

const getters = {
  totalNum(state) {
    return state.products.reduce((prev, cart) => {
      return prev + cart.orders.length
    }, 0)
  },
  totalNumOfSelectedProducts(state, getters) {
    return getters.selectedProducts.reduce((prev, cart) => {
      return prev + cart.orders.length
    }, 0)
  },
  isAllSelected(state) {
    return state.products.every(cart => {
      return cart.orders.every(cart_order => {
        return cart_order.selected || cart_order.product.sold != 0 || cart_order.product.shelf == 0
      })
    })
  },
  selectedPrice(state, getters) {
    return getters.selectedProducts.reduce((prev, cart) => {
      return prev + cart.orders.reduce((prev, cart_order) => {
        return prev + cart_order.product.price
      }, 0)
    }, 0)
  },
  selectedProducts(state) {
    let copyProducts = JSON.parse(JSON.stringify(state.products))
    for(let i = copyProducts.length - 1; i >= 0; i--) {
      for(let j = copyProducts[i].orders.length - 1; j >= 0; j--){     // delete seller's product which is not selected
        if(!copyProducts[i].orders[j].selected) {
          copyProducts[i].orders.splice(j, 1)
        }
      }
      if(copyProducts[i].orders.length == 0) {
        copyProducts.splice(i, 1)
      }
    }
    return copyProducts
  },
  selectedProductsId(state, getters) {
    return getters.selectedProducts.reduce((ids, cart) => {
      return ids.concat(cart.orders.map(cart_order => cart_order.product.id))
    }, [])
  },
  isEmpty(state) {
    return state.products.length == 0
  },
  shippingFee(state, getters) {
    return getters.selectedProducts.reduce((prev, cart) => {
      return prev + cart.fee
    }, 0)
  }
}

const mutations = {
  setProducts(state, products) {
    state.products = products
  },
  setToken(state, token) {
    state.token = token
  },
  setShipping(state, store) {
    state.shipping = store
  },
  setRecipient(state, recipient) {
    state.recipient = recipient
  },
  setShop(state, shop) {
    state.shop = shop
  },
  setLastOrderPrice(state, lastOrderPrice) {
    state.lastOrderPrice = lastOrderPrice
  },
  reset(state) {
    Object.assign(state, defaultState())
  }
}

const actions = {
  getShoppingCartProducts({ commit, state }, payload = {setShop: true} ) {
    axios.get('/member/cart').then(response => {
      commit('setToken', response.data[0].token)
      commit('setShipping', response.data[0].logistics_sub_type)
      let carts = response.data[0].cart_orders.filter(cart => {
        return cart.orders.some(cart_order => cart_order.product)
      })
      let products = carts.map(cart => {
        cart.orders = cart.orders.filter(cart_order => cart_order.product).map(order => {
          if(vm.$route.name == 'Checkout') {
            order.selected = order.pending
          }
          else {
            order.selected = order.product.sold == 0 && order.product.shelf > 0
          }
          return order
        })
        return cart
      })
      commit('setProducts', products)
      let shop = {
        id: response.data[0].shop_id,
        name: response.data[0].shop_name,
        address: response.data[0].shop_address
      }
      payload.setShop ? commit('setShop', shop) : ''
    }).catch(e => {
      if(e.response.data.message.includes('There are products in the request sold')) {
        router.push('/shoppingcart')
        vm.$root.$emit('errorDialog', ['您所選購的商品已售出。請重新選購。'])
      }
    })
  },
  setRecipient({ commit }, recipient) {
    commit('setRecipient', recipient)
  },
  setLastOrderPrice({ commit }, lastOrderPrice) {
    commit('setLastOrderPrice', lastOrderPrice)
  },
  reset({ commit }) {
    commit('reset')
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}